<div class="workSpace">
  <!--nombre y filtro-->
  <div class="w3-container w3-containertemplate" style="height: 7%;">
    <!--Nombre modulo y tablero-->
    <div class="w3-caja-menu padreizquierda w3-quarter">
      <div class="w3-row hijoizquierda centradoVertical">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ 'menu.'+dataService.moduleSelect | translate}}</b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect | translate }}</span>
      </div>
    </div>
    <!--FILTROS-->
    <div class="w3-caja-menu padreizquierda w3-rest">
      <div class="zonasFiltros w3-row centradoVertical">
        <div class="w3-thirty ">
            <div class="w3-right" style="margin-right: 5%;" [ngClass]="{ 'w3-disabled': !filtroPeriodos }">
              {{ 'filtros.rango' | translate }}
            </div>
            <div class="w3-right" style="margin-right: 5%; margin-top: 1%;">
              <input (click)="activacionFiltros()" class="" style="border-width: 1px;" type="checkbox">
            </div>
        </div>
        <div class="w3-rest"  [ngClass]="{ 'w3-disabled': !filtroPeriodos }">
          {{ 'filtros.desde' | translate }}

          @for (anio of Periodos; track $index) {
            @for (mes of anio.series; track $index) {
              <div [ngClass]="{ 'fraseFil w3-round-btn-large w3-center w3-elemento-menu grisBtn w3-button iconoFiltros': mes.check, 'w3-hide': !mes.check}"
              [matMenuTriggerFor]="menuAniosIni">
                <span style="margin-left: 5px;">{{escrituraPeriodo(mes.periodo)}}</span>
              </div>
            }
          }
          <mat-menu class="w3-medium" #menuAniosIni="matMenu">
            @for (anio2 of Periodos; track $index) {
              <button class="mat-menu-item" mat-menu-item [matMenuTriggerFor]="menuMeses">
                {{anio2.anio}}
              </button>
              <mat-menu #menuMeses="matMenu" [overlapTrigger]="false">
                @for (mes2 of anio2.series; track $index) {
                  <button mat-menu-item (click)="$event.stopPropagation(); cambioPeriodo(mes2, 'inicio');">
                    <input [id]="'check_'+mes2.mes+''+mes2.anio"
                    (change)="cambioPeriodo(mes2, 'inicio')" style="cursor: pointer; margin-top: 0.7vh; float: left;"
                    [checked]="mes2.check" type="checkbox"
                    (click)="$event.stopPropagation();">
                    <span style="margin-left: 5px; float: left;">{{'filtros.'+mes2.mes|translate}}</span> 
                  </button>
                }
              </mat-menu>
            }
          </mat-menu>

          {{ 'filtros.hasta' | translate }}

          @for (anio of Periodos2; track $index) {
            @for (mes of anio.series; track $index) {
              <div [ngClass]="{ 'fraseFil w3-round-btn-large w3-center w3-elemento-menu grisBtn w3-button iconoFiltros': mes.check, 'w3-hide': !mes.check}"
              [matMenuTriggerFor]="menuAniosFin">
                <span style="margin-left: 5px;">{{escrituraPeriodo(mes.periodo)}}</span>
              </div>
            }
          }
          <mat-menu class="w3-medium" #menuAniosFin="matMenu">
            @for (anio2 of Periodos2; track $index) {
              @if(anio2.visible){
                <button class="mat-menu-item" mat-menu-item [matMenuTriggerFor]="menuMeses2">
                  {{anio2.anio}}
                </button>
              }
              <mat-menu #menuMeses2="matMenu" [overlapTrigger]="false">
                @for (mes2 of anio2.series; track $index) {
                  @if (mes2.visible) {
                    <button mat-menu-item (click)="$event.stopPropagation(); cambioPeriodo(mes2, 'fin');">
                      <input [id]="'check_'+mes2.mes+''+mes2.anio"
                      (change)="cambioPeriodo(mes2, 'fin')" style="cursor: pointer; margin-top: 0.7vh; float: left;"
                      [checked]="mes2.check" type="checkbox"
                      (click)="$event.stopPropagation();">
                      <span style="margin-left: 5px; float: left;">{{'filtros.'+mes2.mes|translate}}</span> 
                    </button>
                  }
                }
              </mat-menu>
            }
          </mat-menu>
        </div>
      </div>
    <!--FILTRO PERSPECTIVA 1-->
      <div class="w3-quarter centradoVertical" style="margin-right: 1vh;">
        <div class="w3-half hijoizquierda">
          <button class="w3-button w3-right" [matMenuTriggerFor]="menuPerspectivasx">
            {{ 'filtros.persx' | translate }}
            <mat-icon class="iconoMen">expand_more</mat-icon>
          </button>
          <mat-menu class="w3-medium" #menuPerspectivasx="matMenu">
            @for (i of perspectivasx; track i; let j = $index) {
              <button class="mat-menu-item" mat-menu-item [ngClass]="{'w3-disabled':encPersx === i.perspec}" [disabled]="encPersx === i.perspec" (click)="$event.stopPropagation(); cambioPerspectiva(i.perspec, j, 'x');">
                <span>{{i.perspec}}</span>
              </button>
            }
          </mat-menu>
        </div>
        <!--Chip perspectiva seleccionada-->
        <div class="w3-rest hijoizquierda">
          <div class="w3-row padreizquierda containerChips">
            <div class="chips nombres">
              <div class="autoAjuste">
                @for (anio of Periodos; track $index) {
                  @for (mes of anio.series; track $index) {
                    <div [ngClass]="{
                      'w3-round-btn-large grisBtn w3-center w3-elemento-menu w3-button':mes.check,
                      'w3-hide':!mes.check}" class="filtroMesAnioSeleccionado">
                      <span style="margin-left: 5px;">{{encPersx}}</span>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    <!--FILTRO PERSPECTIVA 2-->
      <div class="w3-quarter centradoVertical " style="margin-right: 1vh;">
        <div class="w3-half hijoizquierda">
          <button class="w3-button w3-right" [matMenuTriggerFor]="menuPerspectivasy">
            {{ 'filtros.persy' | translate }}
            <mat-icon class="iconoMen">expand_more</mat-icon>
          </button>
          <mat-menu class="w3-medium" #menuPerspectivasy="matMenu">
            @for (j of perspectivasy; track j; let pos = $index) {
              @if (j.visible) {
                <button class="mat-menu-item" mat-menu-item [ngClass]="{'w3-disabled':encPersy === j.perspec}" [disabled]="encPersy === j.perspec" (click)="$event.stopPropagation(); cambioPerspectiva(j.perspec, pos, 'y');">
                  <span>{{j.perspec}}</span>
                </button>
              }
            }
          </mat-menu>
        </div>
        <!--Chip perspectiva seleccionada-->
        <div class="w3-rest hijoizquierda">
          <div class="w3-row padreizquierda containerChips">
            <div class="chips nombres">
              <div class="autoAjuste">
                @for (anio of Periodos; track $index) {
                  @for (mes of anio.series; track $index) {
                    <div [ngClass]="{
                      'w3-round-btn-large grisBtn w3-center w3-elemento-menu w3-button':mes.check,
                      'w3-hide':!mes.check}" class="filtroMesAnioSeleccionado">
                      <span style="margin-left: 5px;">{{encPersy}}</span>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--PATRIMONIO-->
      @if (patrimonio) {
        <div class="w3-rest centradoVertical" style="margin-right: 1vh;">
          <div class="w3-half hijoizquierda">
            <button class="w3-button w3-right" [matMenuTriggerFor]="menuAniosPat">
              {{ 'operative-potential.analisis.patrimonio' | translate }}
              <mat-icon class="iconoMen">expand_more</mat-icon>
            </button>
            <mat-menu class="w3-medium" #menuAniosPat="matMenu">
              @for (anio of periodosPat; track $index) {
                <button class="mat-menu-item" mat-menu-item [matMenuTriggerFor]="menuMesesPat">
                  {{anio.anio}}
                </button>
                <mat-menu #menuMesesPat="matMenu" [overlapTrigger]="false">
                  @for (mes of anio.series; track $index) {
                    <button mat-menu-item (click)="$event.stopPropagation(); cambioPeriodoPatrimonio(mes);">
                      <input [id]="'check_'+mes.mes+''+mes.anio"
                      (change)="cambioPeriodoPatrimonio(mes)" style="cursor: pointer; margin-top: 0.7vh; float: left;"
                      [checked]="mes.check" type="checkbox"
                      (click)="$event.stopPropagation();">
                      <span style="margin-left: 5px; float: left;">{{'filtros.'+mes.mes|translate}}</span> 
                    </button>
                  }
                </mat-menu>
              }
            </mat-menu>
          </div>
          <!-- Chip periodo patrimonio seleccionado--  -->
          <div class="w3-rest hijoizquierda">
            <div class="w3-row padreizquierda containerChips">
              <div class="chips nombres">
                <div class="autoAjuste">
                  @for (anio of periodosPat; track $index) {
                    @for (mes of anio.series; track $index) {
                      <div [ngClass]="{
                        'w3-round-btn-large grisBtn w3-center w3-elemento-menu w3-button':mes.check,
                        'w3-hide':!mes.check}" class="filtroMesAnioSeleccionado">
                        <span style="margin-left: 5px;">{{escrituraPeriodo(mes.periodo)}}</span>
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    
  </div>

  <!--CONTENIDO DEL TABLERO-->
  <div class="w3-row workSpaceTab">
    <div class="zonaSup w3-white">
      <div class="w3-row headers w3-titulo-contenidomenuSC">
        <div class="w3-threequarter">
          <span class="w3-margin-left-contenido">{{'operative-potential.analisis.tituloTabla' | translate}}</span>
          <span class=""> {{encPersx.toLowerCase()}} y {{encPersy.toLowerCase()}}</span>
          @if (filtroPeriodos) {
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}} - {{escrituraPeriodo(subTitles2)}}</span>
          }
          @if (patrimonio) {
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{ 'operative-potential.analisis.patrimonio' | translate }} {{escritura(montoPatri)}}</span>
          }
        </div>
        <div class="w3-rest w3-right">
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
              [matMenuTriggerFor]="menuTabla">
                more_vert
              </mat-icon>
              <mat-menu #menuTabla="matMenu">
                @if (!perdidax && !perdiday) {
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="menuMetrica">
                    <mat-icon [ngStyle]="{'color':'gray'}">tag</mat-icon>
                    <span>{{'menu.Metrica' | translate}}</span>
                  </button>
                }
                <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarTabla()">
                  <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                  <span>{{'menu.Exportar' | translate}}</span>
                </button>
              </mat-menu>
              <mat-menu #menuMetrica="matMenu">
                <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [ngClass]="{'w3-disabled':metrica === 'num'}" [disabled]="metrica === 'num'" (click)="cambioMetrica('num')">
                  <span>{{'operative-potential.analisis.numero'|translate}}</span>
                </button>
                <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [ngClass]="{'w3-disabled':metrica === 'prop'}" [disabled]="metrica === 'prop'" (click)="cambioMetrica('prop')">
                  <span>{{'operative-potential.analisis.proporcion'|translate}}</span>
                </button>
              </mat-menu>
        </div>
      </div>
      <div class="zonaTabla w3-scroll">
        <table class="w3-table ">
          <thead>
            <tr class="w3-table-titleLow w3-center" style="line-height: 1.2;">
              <th class="w3-border-right-balance stikyColum ancho">{{encPersx}}</th>
              @for (item of titulosx; track $index) {
                <th class="w3-border-right-balance stikyColum ancho">{{item.nombre}}</th>
              }
              @if (!perdidax && !perdiday) {
                <th class="w3-border-right-balance stikyColum ancho">{{ 'operative-potential.analisis.total' | translate}}</th>
              }
              @if (perdiday) {
                <th class="w3-border-right-balance stikyColum ancho">{{ 'operative-potential.analisis.totalg' | translate}}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (y of valores; track y; let i = $index) {
              <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2;">
                @if (i <= valores.length-2 && !perdidax && !perdiday) {
                  <td class="borderAllLow">{{titulosy[i].nombre}}</td>
                }
                @if (i === valores.length-1 && !perdidax && !perdiday) {
                  <td class="borderAllLow w3-table-titleLow">Total</td>
                }
                @if (i <= valores.length-2 && perdidax) {
                  <td class="borderAllLow">{{titulosy[i].nombre}}</td>
                }
                @if (i === valores.length-1 && perdidax) {
                  <td class="borderAllLow w3-table-titleLow">{{ 'operative-potential.analisis.totalg' | translate }}</td>
                }
                @if (i <= valores.length-1 && perdiday) {
                  <td class="borderAllLow">{{titulosy[i].nombre}}</td>
                }
                @for (val of valores[i]; track val; let j = $index) {
                  @if (metrica == 'num' && !perdidax && !perdiday) {
                    <td [ngClass]="{ 'w3-table-titleLow' : j === valores[i].length-1 || i === valores.length-1}" class="borderAllLow alinCenter">{{val}}</td>
                  }
                  @if (metrica == 'prop' && !perdidax && !perdiday) {
                    <td [ngClass]="{ 'w3-table-titleLow' : j === valores[i].length-1 || i === valores.length-1}" class="borderAllLow alinCenter">{{val}} %</td>
                  }
                  @if (perdidax && encPersx === 'Perdida') {
                    <td [ngClass]="{ 'w3-table-titleLow' : i === valores.length-1}" class="borderAllLow alinCenter">
                      {{escritura(val)}} @if (j>2) { % }
                    </td>
                  }
                  @if (perdiday && encPersy === 'Perdida') {
                    <td [ngClass]="{ 'w3-table-titleLow' : j === valores[i].length-1}" class="borderAllLow alinCenter">
                      {{escritura(val)}} @if (i>2) { % } 
                    </td>
                  }
                  @if (perdidax && encPersx === 'Pérdida patrimonial') {
                    <td [ngClass]="{ 'w3-table-titleLow' : i === valores.length-1}" class="borderAllLow alinCenter">
                      {{escritura(val)}} @if (j===2) { % } 
                    </td>
                  }
                  @if (perdiday && encPersy === 'Pérdida patrimonial') {
                    <td [ngClass]="{ 'w3-table-titleLow' : j === valores[i].length-1}" class="borderAllLow alinCenter">
                      {{escritura(val)}} @if (i===2) { % }
                    </td>
                  }
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <div class="zonaInf w3-white" id="conteGraf">
      <div class="w3-row headers w3-titulo-contenidomenuSC">
        <div class="w3-half"> <!--titulo tabla-->
          <span class="w3-margin-left-contenido">{{
            'operative-potential.analisis.tituloTabla'  | translate}}
          </span>
          <span class=""> {{encPersx.toLowerCase()}} y {{encPersy.toLowerCase()}} </span>
          @if (filtroPeriodos) {
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}} - {{escrituraPeriodo(subTitles2)}}</span>
          }
          @if (patrimonio) {
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{ 'operative-potential.analisis.patrimonio' | translate }} {{escritura(montoPatri)}}</span>
          }
        </div>
        <!--menu grafica-->
        <div class="w3-rest w3-right " > 
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" (click)="ampliarGraf()">
            zoom_out_map
          </mat-icon>
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
          [matMenuTriggerFor]="menuGrafica">
            more_vert
          </mat-icon>
          <mat-menu #menuGrafica="matMenu">
            @if (encPersx == 'Pérdida patrimonial' || encPersy == 'Pérdida patrimonial') {
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="tipoGrafica">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                <span>{{'financiero.catalogoCuentas.tooltipIcono3'|translate}}</span>
              </button>
            }     
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarGrafica('conteGraf', 'operative-potential.analisis.tituloTabla',  encPersx.toLowerCase() + ' y ' + encPersy.toLowerCase())">
              <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
              <span>{{'menu.Exportar' | translate}}</span>
            </button>
          </mat-menu>
          <mat-menu #tipoGrafica="matMenu">
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [ngClass]="{'w3-disabled':tipoGraf === 'bar' &&  hori}" [disabled]="tipoGraf === 'bar' && hori" (click)="grafPatrimonio('bar',true)">
              <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
              <span>{{'operative-potential.analisis.barras'|translate}}</span>
            </button>
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [ngClass]="{'w3-disabled':tipoGraf === 'bar' && !hori}" [disabled]="tipoGraf === 'bar' &&!hori" (click)="grafPatrimonio('bar',false)">
              <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
              <span>{{'operative-potential.analisis.columnas'|translate}}</span>
            </button>
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [ngClass]="{'w3-disabled':tipoGraf === 'line'}" [disabled]="tipoGraf === 'line'" (click)="grafPatrimonio('line',false)">
              <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
              <span>{{'operative-potential.analisis.lineal'|translate}}</span>
            </button>
          </mat-menu>
          
        </div>
      </div>
      <div class="zonaGraf ">
        @if (encPersx == 'Pérdida patrimonial' || encPersy == 'Pérdida patrimonial') {
          <div id="graficaPat"></div>
        }
        @if (encPersx != 'Pérdida patrimonial' && encPersy != 'Pérdida patrimonial') {
          <ngx-charts-bubble-chart
          [maxXAxisTickLength]="8"
          [maxYAxisTickLength]="8"
          [scheme]="colorScheme"
          [results]="datosGraf"
          [showGridLines]="false"
          [xAxis]="showXAxis"
          [yAxis]="showYAxis"
          [legend]="showLegend"
          [showXAxisLabel]="showXAxisLabel"
          [showYAxisLabel]="showYAxisLabel"
          [xAxisLabel]="xAxisLabel"
          [yAxisLabel]="yAxisLabel"
          [xScaleMin]="xScaleMin"
          [xScaleMax]="xScaleMax"
          [yScaleMin]="yScaleMin"
          [yScaleMax]="yScaleMax"
          [minRadius]="minRadius"
          [maxRadius]="maxRadius">
        </ngx-charts-bubble-chart>
        }
      </div>
    </div>
  </div>

</div>


<!--Modal ampliar grafica-->
<div id="ampliar" class="modal" (click)="clickFuera($event)">
  <div class="modalContent " style="width: 80%;">
    <div class="w3-row w3-white">
      <!--Titulo grafica modal-->
      <div class="w3-row w3-noventa2 w3-white">
        <div class="w3-row  w3-header-cuadrante padreizquierda" style="height: 6vh; margin-top: 10px; margin-left: 20px">
          <div class="w3-noventa2 w3-titulo-contenidomenu bottom hijoizquierdaTitle" >
            <span class="w3-margin-left-contenido">{{
              'operative-potential.analisis.tituloTabla' | translate}}
            </span>
            <span class=""> {{encPersx.toLowerCase()}} y {{encPersy.toLowerCase()}} </span>
            @if (filtroPeriodos) {
              <span class="w3-margin-left-contenido">&bull;</span>
              <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}} - {{escrituraPeriodo(subTitles2)}}</span>
            }
            @if (patrimonio) {
              <span class="w3-margin-left-contenido">&bull;</span>
              <span class="w3-margin-left-filter w3-subtitulo">{{ 'operative-potential.analisis.patrimonio' | translate }} {{escritura(montoPatri)}}</span>
            }
          </div>
        </div>
      </div>
      <!--cerrar modal-->
      <div class="w3-rest w3-right w3-white" style="height: 6vh; margin-top: 10px;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" (click)="closeModal()">clear</mat-icon>
        </div>
      </div>
    </div>
    
    <!--area grafica-->
    <div style="padding-left: 2%; padding-bottom: 1%; padding-right: 2%;">
      @if (encPersx != 'Pérdida patrimonial' && encPersy != 'Pérdida patrimonial') {
        <div class="w3-row contentGraf">
          <ngx-charts-bubble-chart
            [scheme]="colorScheme"
            [results]="datosGraf"
            [showGridLines]="false"
            [xAxis]="showXAxis"
            [yAxis]="showYAxis"
            [legend]="showLegend"
            [showXAxisLabel]="showXAxisLabel"
            [showYAxisLabel]="showYAxisLabel"
            [xAxisLabel]="xAxisLabel"
            [yAxisLabel]="yAxisLabel"
            [xScaleMin]="xScaleMin"
            [xScaleMax]="xScaleMax"
            [yScaleMin]="yScaleMin"
            [yScaleMax]="yScaleMax"
            [minRadius]="minRadius"
            [maxRadius]="maxRadius">
          </ngx-charts-bubble-chart>
        </div>
      }
      @if (encPersx == 'Pérdida patrimonial' || encPersy == 'Pérdida patrimonial') {
        <div class="w3-row contentGraf">
          <div  id="graficaPatAmp"></div>
        </div>
      }
    </div>
  </div>
</div>